import { useEffect, useState } from "react";
import Joi from "joi-browser";

export default useExternalApiForm;

export const externalApiFormSchema = {
  name: Joi.string().required().label("Name"),
  description: Joi.string().allow(null, "").label("Description"),
  headers: Joi.object().optional().default({}).label("Headers"),
  body: Joi.any().optional().default({}).label("Body"),
  queryParams: Joi.object().optional().default({}).label("Query Parameters"),
  authentication: Joi.object().optional().default({}).label("Authentication"),
  url: Joi.string().required().label("URL"),
  method: Joi.string().required().label("Method"),
};

export const getExternalApiConfigureData = (externalApiConfig) => {
  return {
    name: externalApiConfig.name,
    description: externalApiConfig.description,
    headers: externalApiConfig.headers,
    queryParams: externalApiConfig.queryParams,
    body: externalApiConfig.body,
    method: externalApiConfig.method,
    url: externalApiConfig.url,
    authentication: externalApiConfig.authentication,
  };
};

function useExternalApiForm(externalApiConfig, validationErrors = {}) {
  const [formState, setFormState] = useState(() =>
    getExternalApiConfigureData(externalApiConfig),
  );
  const [errors, setErrors] = useState(validationErrors);

  useEffect(() => {
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const schema = Joi.object(externalApiFormSchema);
    const { error } = schema.validate(formState, { abortEarly: false });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      fieldErrors[detail.path[0]] = detail.message;
    });
    setErrors(fieldErrors);
    return false;
  };

  return { formState, validate, updateFormState, errors };
}
